import classNames from 'classnames';
import { FC, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { StylesheetContext } from '../../contexts/StylesheetContext';
import { isSFChatAvailable, isWhatsappAvailable, startChat } from '../../services/ChatService';
import { Separator } from '../Separator/Separator';
import { Tag } from '../Tag/Tag';
import WhatsAppButton from '../WhatsAppButton/WhatsAppButton';
import styles from './ContactChatContainer.module.scss';

export const ContactChatContainer: FC= () => {
  const { stylesheet } = useContext(StylesheetContext);
  const { t } = useTranslation();
  const isChatAvailable = isSFChatAvailable();
  const isWhatsAppAvailable = isWhatsappAvailable(stylesheet);

  const isDesktopOnly = isChatAvailable && !isWhatsAppAvailable;

  if (!isChatAvailable && !isWhatsAppAvailable) {
    return null;
  }

  return (
    <>
      <div className={classNames(styles.container, isDesktopOnly && styles.hideTillMobile)}>
        <div className={styles.header}>
          <h2>{t('contact:chatWithSF')}</h2>
          <Tag
            icon={<img alt="quick watch" height={14} src="/assets/quick_watch.png" />}
            text={t('contact:fastest')}
          />
        </div>
        <p><Trans>{t('contact:chatWithSFDescription')}</Trans></p>
        {isChatAvailable && (
          <div className={styles.showAfterTablet}>
            <button aria-label={t('contact:startLiveChat')} className={styles.elementButton} onClick={startChat}>
              <img alt="chat" src="/assets/message.svg" />
              {t('contact:startLiveChat')}
            </button>
          </div>
        )}
        {isWhatsAppAvailable && (
          <div className={styles.elementContent}>
            <div className={styles.whatsAppSection}>
              <WhatsAppButton
                customButtonClassName={classNames(styles.showAfterMobile, styles.elementButton)}
                regularButtonClassname={styles.whatsAppRegularButton}
                text={t('contact:askQuestionViaWhatsApp')}
                variant="customButton"
              />
              <p className={styles.showAfterMobile}>{`(${stylesheet.contact.whatsappNumber})`}</p>
            </div>
            <p className={classNames(styles.showAfterMobile, styles.whatsAppDescription)}>{t('contact:whatsAppDescription')}</p>
          </div>
        )}
      </div>
      <Separator classes={classNames(isDesktopOnly && styles.hideTillMobile)} />
    </>
  );
};
